import defs from '../../_core/defs.js';
import matreshkaError from '../../_helpers/matreshkaerror.js';
// checks is item already rendered in an array
// selfDef is given instead of itself (array) for perf optimisation
export default function checkAlreadyRendered(_ref) {
  var item = _ref.item,
    selfDef = _ref.selfDef;
  var itemDef = defs.get(item);
  var selfId = selfDef.id;
  // if item object is defined in object defs
  if (itemDef) {
    var renderedInArrays = itemDef.renderedInArrays;
    // if item's node is already rendered for an array
    // then throw an error
    if (renderedInArrays != null && renderedInArrays[selfId]) {
      throw matreshkaError('array:add_render_twice');
    }
  }
}